import { driver } from 'driver.js';

const driverObj = driver();

const initNode = (node) => {
  node.classList.add('tour_initialized');

  const visible = node.getAttribute('data-visible') || 'true';
  if (visible === 'false') { return; }

  const title        = node.getAttribute('data-title');
  const description  = node.getAttribute('data-description');
  const position     = node.getAttribute('data-position');
  const closeBtnText = node.getAttribute('data-closeBtnText') || 'Close';

  driverObj.highlight({
    element: node,
    popover: {
      title,
      description,
      position,
      closeBtnText,
    },
  });
};

const initAll = () => {
  const nodes = document.querySelectorAll('.tour:not(.tour_initialized)');
  Array.from(nodes).forEach(node => initNode(node));
};

const start = () => {
  document.addEventListener('page:load', initAll);
  document.addEventListener('ajax:success', initAll);
};

export default { initAll, start };
